import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_FORMAT_SHOW } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterEmissaoRendaFixaOfertaTable = (props) => {
    const datalakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        datalakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        }).catch((err) => {
            props.loading(false)
            props.callbackError(err)
        }).finally(() => {
            props.loading(false)
        })
    }

    const createRow = async () => {
        const body = {
            RendaFixaCaracteristicasID: 1,
            Distribuicao: null,
            LinkSRE: null,
            SituacaoDistribuicao: null,
            SituacaoOferta: null,
            TipoMercado: null,
            TipoRito: null,
            Bookbuilding: null,
            RegimeDistribuicao: null,
            PublicoAlvoInvestidorGeralInicial: null,
            PublicoAlvoInvestidorQualificadoInicial: null,
            PublicoAlvoInvestidorProfissionalInicial: null,
            PublicoAlvoInvestidorGeralFinal: null,
            PublicoAlvoInvestidorQualificadoFinal: null,
            PublicoAlvoInvestidorProfissionalFinal: null,
            DataRequerimento: null,
            DataRegistro: null,
            DataInicioOferta: null,
            DataEncerramentodaOfertaMaximo: null,
            DataEncerramentodaOfertaEfetivo: null,
            DataInicioReserva: null,
            DatasEncerramentoReserva: null,
            DataBookbuilding: null,
            DataLockupIGparaIG: null,
            DataLockupIGparaIQ: null,
            DataLockupIGparaIP: null,
            DataLockupIQparaIG: null,
            DataLockupIQparaIQ: null,
            DataLockupIQparaIP: null,
            DataLockupIPparaIG: null,
            DataLockupIPparaIQ: null,
            DataLockupIPparaIP: null,
            CPFCNPJ_CoordenadorLider: null,
            CPFCNPJ_Coordenador1: null,
            CPFCNPJ_Coordenador2: null,
            CPFCNPJ_Coordenador3: null,
            CPFCNPJ_Coordenador4: null,
            CPFCNPJ_Coordenador5: null,
            CPFCNPJ_Coordenador6: null,
            CPFCNPJ_Coordenador7: null
        }

        props.loading(true)
        return datalakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const {
            ID, RendaFixaCaracteristicasID, Distribuicao, LinkSRE, SituacaoDistribuicao, SituacaoOferta,
            TipoMercado, TipoRito, Bookbuilding, RegimeDistribuicao, 
            PublicoAlvoInvestidorGeralInicial, PublicoAlvoInvestidorQualificadoInicial, 
            PublicoAlvoInvestidorProfissionalInicial, PublicoAlvoInvestidorGeralFinal, 
            PublicoAlvoInvestidorQualificadoFinal, PublicoAlvoInvestidorProfissionalFinal, 
            DataRequerimento, DataRegistro, DataInicioOferta, DataEncerramentodaOfertaMaximo, 
            DataEncerramentodaOfertaEfetivo, DataInicioReserva, DatasEncerramentoReserva, 
            DataBookbuilding, DataLockupIGparaIG, DataLockupIGparaIQ, DataLockupIGparaIP, 
            DataLockupIQparaIG, DataLockupIQparaIQ, DataLockupIQparaIP, DataLockupIPparaIG, 
            DataLockupIPparaIQ, DataLockupIPparaIP, CPFCNPJ_CoordenadorLider, CPFCNPJ_Coordenador1, 
            CPFCNPJ_Coordenador2, CPFCNPJ_Coordenador3, CPFCNPJ_Coordenador4, CPFCNPJ_Coordenador5, 
            CPFCNPJ_Coordenador6, CPFCNPJ_Coordenador7
        } = newRow

        const body = {
            "RendaFixaCaracteristicasID": RendaFixaCaracteristicasID,
            "Distribuicao": Distribuicao,
            "LinkSRE": LinkSRE,
            "SituacaoDistribuicao": SituacaoDistribuicao,
            "SituacaoOferta": SituacaoOferta,
            "TipoMercado": TipoMercado,
            "TipoRito": TipoRito,
            "Bookbuilding": Bookbuilding,
            "RegimeDistribuicao": RegimeDistribuicao,
            "PublicoAlvoInvestidorGeralInicial": PublicoAlvoInvestidorGeralInicial,
            "PublicoAlvoInvestidorQualificadoInicial": PublicoAlvoInvestidorQualificadoInicial,
            "PublicoAlvoInvestidorProfissionalInicial": PublicoAlvoInvestidorProfissionalInicial,
            "PublicoAlvoInvestidorGeralFinal": PublicoAlvoInvestidorGeralFinal,
            "PublicoAlvoInvestidorQualificadoFinal": PublicoAlvoInvestidorQualificadoFinal,
            "PublicoAlvoInvestidorProfissionalFinal": PublicoAlvoInvestidorProfissionalFinal,
            "DataRequerimento": DataRequerimento,
            "DataRegistro": DataRegistro,
            "DataInicioOferta": DataInicioOferta,
            "DataEncerramentodaOfertaMaximo": DataEncerramentodaOfertaMaximo,
            "DataEncerramentodaOfertaEfetivo": DataEncerramentodaOfertaEfetivo,
            "DataInicioReserva": DataInicioReserva,
            "DatasEncerramentoReserva": DatasEncerramentoReserva,
            "DataBookbuilding": DataBookbuilding,
            "DataLockupIGparaIG": DataLockupIGparaIG,
            "DataLockupIGparaIQ": DataLockupIGparaIQ,
            "DataLockupIGparaIP": DataLockupIGparaIP,
            "DataLockupIQparaIG": DataLockupIQparaIG,
            "DataLockupIQparaIQ": DataLockupIQparaIQ,
            "DataLockupIQparaIP": DataLockupIQparaIP,
            "DataLockupIPparaIG": DataLockupIPparaIG,
            "DataLockupIPparaIQ": DataLockupIPparaIQ,
            "DataLockupIPparaIP": DataLockupIPparaIP,
            "CPFCNPJ_CoordenadorLider": CPFCNPJ_CoordenadorLider,
            "CPFCNPJ_Coordenador1": CPFCNPJ_Coordenador1,
            "CPFCNPJ_Coordenador2": CPFCNPJ_Coordenador2,
            "CPFCNPJ_Coordenador3": CPFCNPJ_Coordenador3,
            "CPFCNPJ_Coordenador4": CPFCNPJ_Coordenador4,
            "CPFCNPJ_Coordenador5": CPFCNPJ_Coordenador5,
            "CPFCNPJ_Coordenador6": CPFCNPJ_Coordenador6,
            "CPFCNPJ_Coordenador7": CPFCNPJ_Coordenador7
        }

        props.loading(true)
        return datalakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return datalakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }


    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        datalakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        datalakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'RendaFixaCaracteristicasID',
            headerName: 'RendaFixaCaracteristicasID',
            flex: 1,
            minWidth: 200,
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Distribuicao',
            headerName: 'Distribuicao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'LinkSRE',
            headerName: 'LinkSRE',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'SituacaoDistribuicao',
            headerName: 'SituacaoDistribuicao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'SituacaoOferta',
            headerName: 'SituacaoOferta',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'TipoMercado',
            headerName: 'TipoMercado',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'TipoRito',
            headerName: 'TipoRito',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Bookbuilding',
            headerName: 'Bookbuilding',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'RegimeDistribuicao',
            headerName: 'RegimeDistribuicao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'PublicoAlvoInvestidorGeralInicial',
            headerName: 'PublicoAlvoInvestidorGeralInicial',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'PublicoAlvoInvestidorQualificadoInicial',
            headerName: 'PublicoAlvoInvestidorQualificadoInicial',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'PublicoAlvoInvestidorProfissionalInicial',
            headerName: 'PublicoAlvoInvestidorProfissionalInicial',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'PublicoAlvoInvestidorGeralFinal',
            headerName: 'PublicoAlvoInvestidorGeralFinal',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'PublicoAlvoInvestidorQualificadoFinal',
            headerName: 'PublicoAlvoInvestidorQualificadoFinal',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'PublicoAlvoInvestidorProfissionalFinal',
            headerName: 'PublicoAlvoInvestidorProfissionalFinal',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DataRequerimento',
            headerName: 'DataRequerimento',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataRegistro',
            headerName: 'DataRegistro',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataInicioOferta',
            headerName: 'DataInicioOferta',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataEncerramentodaOfertaMaximo',
            headerName: 'DataEncerramentodaOfertaMaximo',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataEncerramentodaOfertaEfetivo',
            headerName: 'DataEncerramentodaOfertaEfetivo',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataInicioReserva',
            headerName: 'DataInicioReserva',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DatasEncerramentoReserva',
            headerName: 'DatasEncerramentoReserva',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataBookbuilding',
            headerName: 'DataBookbuilding',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataLockupIGparaIG',
            headerName: 'DataLockupIGparaIG',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataLockupIGparaIQ',
            headerName: 'DataLockupIGparaIQ',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataLockupIGparaIP',
            headerName: 'DataLockupIGparaIP',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataLockupIQparaIG',
            headerName: 'DataLockupIQparaIG',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataLockupIQparaIQ',
            headerName: 'DataLockupIQparaIQ',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataLockupIQparaIP',
            headerName: 'DataLockupIQparaIP',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataLockupIPparaIG',
            headerName: 'DataLockupIPparaIG',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
         {
            field: 'DataLockupIPparaIQ',
            headerName: 'DataLockupIPparaIQ',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
         {
            field: 'DataLockupIPparaIP',
            headerName: 'DataLockupIPparaIP',
            flex: 1,
            minWidth: 150,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'CPFCNPJ_CoordenadorLider',
            headerName: 'CPFCNPJ_CoordenadorLider',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ_Coordenador1',
            headerName: 'CPFCNPJ_Coordenador1',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ_Coordenador2',
            headerName: 'CPFCNPJ_Coordenador2',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ_Coordenador3',
            headerName: 'CPFCNPJ_Coordenador3',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ_Coordenador4',
            headerName: 'CPFCNPJ_Coordenador4',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ_Coordenador5',
            headerName: 'CPFCNPJ_Coordenador5',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ_Coordenador6',
            headerName: 'CPFCNPJ_Coordenador6',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ_Coordenador7',
            headerName: 'CPFCNPJ_Coordenador7',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                pagination={pagination}
                onChangePage={changePage}
                filterFunction={onFilter}
                customFilter={true} />
        </div>
    )
}

ParameterEmissaoRendaFixaOfertaTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterEmissaoRendaFixaOfertaTable